
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";

export const MobileFooterAction = () => {
  return (
    <div className="border-t p-3">
      <Link
        to="/auth"
        className="flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 w-full py-2.5 rounded-lg transition-colors"
      >
        <LogOut className="w-4 h-4" />
        <span className="text-sm font-medium">Sign Out</span>
      </Link>
      <div className="text-center mt-2 text-xs text-gray-500">
        <p>DGK Hub v1.0.0</p>
      </div>
    </div>
  );
};
